import React from 'react';
import { ShieldCheck, Droplets, Zap } from 'lucide-react';
interface SciencePillarProps {
  number: 1 | 2 | 3;
  title: string;
  description: string;
  ingredients: string[];
}
export function SciencePillar({
  number,
  title,
  description,
  ingredients
}: SciencePillarProps) {
  const icons = {
    1: Zap,
    2: Droplets,
    3: ShieldCheck
  };
  const Icon = icons[number];
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-1">
      <div className="flex items-center mb-4" data-id="element-2">
        <div className="w-12 h-12 bg-[#1e3a5f] text-white rounded-full flex items-center justify-center text-xl font-bold mr-4 shrink-0" data-id="element-3">
          {number}
        </div>
        <h3 className="text-xl font-bold text-[#1e3a5f] uppercase tracking-wide" data-id="element-4">
          {title}
        </h3>
      </div>

      <div className="mb-6 flex-grow" data-id="element-5">
        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-6">{description}</p>
      </div>

      <div className="bg-blue-50 p-4 rounded-lg mt-auto" data-id="element-7">
        <div className="flex items-center mb-2" data-id="element-8">
          <Icon className="w-5 h-5 text-[#1e3a5f] mr-2" data-id="element-9" />
          <span className="font-semibold text-[#1e3a5f] text-sm uppercase" data-id="element-10">
            Key Ingredients
          </span>
        </div>
        <ul className="space-y-1" data-id="element-11">
          {ingredients.map((ing, idx) => <li key={idx} className="text-sm text-gray-700 flex items-start" data-id="element-12">
              <span className="mr-2 text-blue-400" data-id="element-13">•</span>
              {ing}
            </li>)}
        </ul>
      </div>
    </div>;
}